import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import {
  CommonEditButton,
  CommonGridToolBarWithFilterText,
  DeletePopup,
} from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from "../../../Components/Loader";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { DataGrid } from "@mui/x-data-grid";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const TherapyChecklist = () => {
  const [formState, setFormState] = useState({
    category: null,
    name: "",
    treatments: [],
  });

  const [checkList, setCheckList] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [EditID, setEditID] = useState(null);
  const [message, setMessage] = useState({
    isErrorMsgText: "",
    successMsgText: "",
    isErrorMsg: false,
    successMsg: false,
  });
  const [treatments, setTreatments] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [delIDs, setdelIDs] = useState([]);
  const [CheckBoxList, setCheckBoxList] = useState([]);
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);

  const categoryList = ["Equipments", "Materials"];

  let commonDisable = CheckAccessFunc(
    "ayurveda",
    "Settings",
    "Therapy Config",
    "Therapy Checklist",
    "SubTab"
  )?.editAccess;

  useEffect(() => {       
    getChecklist();
    getTreatments();
  }, []);

  const getChecklist = () => {
    try {
      setisloader(true);
      RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPY_CHECKLIST_MASTER)
        .then((response) => {
          if (response.data.status === "success") {
            setCheckList(response?.data?.data || []);
          }
          setisloader(false);
        })
        .catch((e) => {
          setisloader(false);
          errorMessage(e?.message);
        });
    } catch (e) {
      setisloader(false);
      errorMessage(e?.message);
    }
  };

  const AddChecklist = () => {
    try {
      if (!formState.category)
        return errorMessage("Please select Category");
      if (!formState.name?.trim())
        return errorMessage("Please enter Name");
      if (!formState.treatments.length)
        return errorMessage("Please select at least one Treatment");

      let data = {
        category: formState.category,
        name: formState.name.trim(),
        treatment_ms: formState?.treatments?.map((t) => t.id),
        is_active: isActive,
      };

      setisloader(true);
      let apiCall = EditID
        ? RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_THERAPY_CHECKLIST_MASTER)
        : RestAPIService.create(data, Serviceurls.AYURVEDA_THERAPY_CHECKLIST_MASTER);

      apiCall
        .then((response) => {
          if (response.data.status === "success") {
            successMessage(response.data.message);
            clearForm();
            getChecklist();
          }
          setisloader(false);
        })
        .catch((e) => {
          setisloader(false);
          errorMessage(e?.message);
        });
    } catch (e) {
      setisloader(false);
      errorMessage(e?.message);
    }
  };

  const getTreatments = () => {
    try {
      RestAPIService.getAll(Serviceurls.AYURVEDA_TREATMENT_MASTER)
        .then((response) => {
          if (response.data.status === "success") {
            setTreatments(response?.data?.data || []);
          }
        })
        .catch((e) => {
          errorMessage(e?.message);
        });
    } catch (e) {
      errorMessage(e?.message);
    }
  };

  const clearForm = () => {
    setFormState({
      category: null,
      name: "",
      treatments: [],
    });
    setIsActive(true);
    setEditID(null);
  };

  const deleteChecklist = () => {
    try {
      let ID = deletedID ? [deletedID] : delIDs || [];
      RestAPIService.delete(Serviceurls.AYURVEDA_THERAPY_CHECKLIST_MASTER + `?ids=${ID}`)
        .then((response) => {
          if (response.data.status === "success") {
            successMessage(response.data.message);
            getChecklist();
            setdelIDs([]);
            setCheckBoxList([]);
            setdeletedID(null);
            setisDelete(false);
          }
        })
        .catch((e) => errorMessage(e?.message));
    } catch (e) {
      errorMessage(e?.message);
    }
  };

  const errorMessage = (msg) =>
    setMessage({ ...message, isErrorMsg: true, isErrorMsgText: msg });

  const successMessage = (msg) =>
    setMessage({ ...message, successMsg: true, successMsgText: msg });

  const msgClose = () =>
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: "",
      successMsg: false,
      successMsgText: "",
    });

  const tableView = () => {
    const grpDelete = () => setisDelete(true);
    const gridToolBar = () => (
      <Box>
        <CommonGridToolBarWithFilterText
          isDelete={delIDs?.length > 0}
          removeData={grpDelete}
        />
      </Box>
    );

    const handleTableCheckbox = (id) => {
      let selectedIDs = new Set(id);
      setCheckBoxList(id);
      let selectedRows = checkList?.filter((row) => selectedIDs.has(row.sno));
      let FinalData = selectedRows.map((item) => item.id);
      setdelIDs(FinalData);
    };

    checkList?.forEach((element, index) => (element.sno = index + 1));

    const columns = [
      {
        field: "sno",
        headerName: "S.No",
        flex: 0.05,
        sortable: false,
        renderCell: (params) => (
          <Typography fontSize={"0.9vw"}>
            {params.row.sno}
          </Typography>
        ),
      },
      { field: "category", headerName: "Category", flex: 0.3 },
      { field: "name", headerName: "Name", flex: 0.3 },
      {field: "treatment_ms", headerName: "Treatment Count", flex: 0.3, renderCell: (params) => (
        <Box>
          {params.row.treatment_ms?.length || 0}
        </Box>
      )},
      {
        field: "is_active",
        headerName: "Status",
        flex: 0.1,
        renderCell: (params) => (
          <Box>{params.row.is_active ? "Active" : "Inactive"}</Box>
        ),
      },
      ...(commonDisable
        ? [
          {
            field: "action",
            headerName: "Action",
            flex: 0.15,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
              <Stack direction="row" spacing={1}>
                <CommonEditButton
                  size="1.5vw"
                  onClick={() => {
                    const treatmentMs = params.row.treatment_ms || [];
                    const treatmentObjects = treatmentMs.map((t) =>
                      typeof t === "object" && t !== null && t.treatment_name != null
                        ? t
                        : treatments.find((tr) => tr.id === t)
                    ).filter(Boolean);
                    setFormState({
                      category: params.row.category,
                      name: params.row.name,
                      treatments: treatmentObjects,
                    });
                    setIsActive(params.row.is_active || false);
                    setEditID(params.row.id);
                  }}
                />
              </Stack>
            ),
          },
        ]
        : []),
    ];

    return (
      <Box sx={{ height: "64vh" }}>
        <DataGrid
          checkboxSelection={commonDisable ? true : false}
          rowSelectionModel={CheckBoxList}
          onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
          rows={checkList || []}
          columns={columns}
          getRowId={(row) => row["sno"]}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {"No Records To Be Shown"}
              </Box>
            ),
          }}
          pageSizeOptions={[10, 20, 30]}
          pagination
          paginationMode="client"
          paginationModel={{
            page: page || 0,
            pageSize: pageSize || 10,
          }}
          onPaginationModelChange={(model) => {
            setpage(model.page)
            setpageSize(model.pageSize)
          }}
          headerHeight={40}
          density="compact"
          disableRowSelectionOnClick
          loading={isloader}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        height: "79.5vh",
        width: "94vw",
        backgroundColor: Colors.Background,
        padding: ".5vw",
      }}
    >
      {/* Form Section */}
      <Box
        sx={{
          height: "13vh",
          width: "93vw",
          backgroundColor: "white",
          padding: "0.5vw",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "1vw",
            flexWrap: "wrap",
          }}
        >
          <Autocomplete
            options={categoryList}
            value={formState?.category}
            onChange={(e, val) =>
              setFormState((p) => ({ ...p, category: val }))
            }
            renderInput={(params) => (
              <TextField {...params} label="Category *" size="small" />
            )}
            sx={{ width: "20vw" }}
          />

          <TextField
            size="small"
            label="Name *"
            value={formState?.name}
            onChange={(e) =>
              setFormState((p) => ({ ...p, name: e.target.value }))
            }
            sx={{ width: "25vw" }}
            inputProps={{ maxLength: 100 }}
          />

          <Autocomplete
            multiple
            size="small"
            limitTags={2}
            options={treatments}
            value={formState.treatments}
            getOptionLabel={(o) => o?.treatment_name || o?.name || String(o?.id ?? "")}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            onChange={(e, val) =>
              setFormState((prev) => ({ ...prev, treatments: val }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Treatments *"
                size="small"
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    flexWrap: "nowrap",
                    overflow: "hidden"
                  }
                }}
              />
            )}
            sx={{
              width: "25vw",
              "& .MuiAutocomplete-tag": {
                maxWidth: "70px"
              }
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                disabled={!EditID}
                size="small"
              />
            }
            label="Active"
          />
          <Box>
            <Button
              size="small"
              variant="outlined"
              sx={{ textTransform: "capitalize", mr: 1 }}
              disabled={!commonDisable}
              onClick={clearForm}
            >
              Clear
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: "capitalize" }}
              disabled={!commonDisable}
              onClick={AddChecklist}
            >
              {EditID ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Table Section */}
      <Box
        sx={{
          height: "64vh",
          width: "93vw",
          mt: ".5vw",
          backgroundColor: "white",
        }}
      >
        {tableView()}
      </Box>

      {/* Toast + Loader + Delete */}
      {message.isErrorMsg && (
        <ToastMsg
          severity="error"
          msg={message.isErrorMsgText}
          msgPop={msgClose}
        />
      )}
      {message.successMsg && (
        <ToastMsg
          severity="success"
          msg={message.successMsgText}
          msgPop={msgClose}
        />
      )}
      {isDelete && (
        <DeletePopup
          DeletTitle="This action will delete the Checklist. Are you sure?"
          DeleteNotify="This action cannot be undone."
          deleteAlertPopupClose={() => {
            setisDelete(false);
            setdeletedID(null);
          }}
          removeData={deleteChecklist}
          ButtonText="Yes"
        />
      )}
      <Loader loaderOpen={isloader} />
    </Box>
  );
};

export default TherapyChecklist;
